import { Link, Stack, Typography } from '@mui/material';
import SidebarBottomLink from 'components/sidebar/sidebar-bottom-link/sidebar-bottom-link.component';
import SidebarLink from 'components/sidebar/sidebar-link/sidebar-link.component';
import { RouteHandleType } from 'pages/main-routes';
import { useMemo } from 'react';
import {
  matchPath,
  Link as RouterLink,
  useLocation,
  useMatches,
} from 'react-router-dom';

const IncPageBreadcrumbs = () => {
  const location = useLocation();
  const matches = useMatches();
  const crumbs = useMemo(
    () =>
      matches
        .filter(match => {
          const handle = match.handle as RouteHandleType;
          if (!handle) return false;
          else
            return (
              handle.page?.breadcrumb !== false &&
              !!handle.page?.title &&
              (!handle.page?.sidebar ||
                handle.page?.sidebar?.component.name === SidebarLink.name ||
                handle.page?.sidebar?.component.name === SidebarBottomLink.name)
            );
        })
        .map(match => ({
          title: (match.handle as RouteHandleType).page.title(),
          pathname: match.pathname,
          matches: matchPath(match.pathname, location.pathname),
        })),
    [location.pathname, matches],
  );

  // If there's only 1 breadcrumb then there is no need to render the breadcrumbs. There is no "trail" to follow
  if (crumbs.length < 2) return null;

  return (
    <>
      <Stack
        component="ol"
        direction="row"
        divider={<Typography>/</Typography>}
        spacing={0.5}
        sx={{ listStyle: 'none', px: 2, m: 0, whiteSpace: 'nowrap' }}
      >
        {crumbs.map((crumb, index) => (
          <li key={index}>
            {!crumb.matches ? (
              <Link component={RouterLink} to={crumb.pathname}>
                {crumb.title}
              </Link>
            ) : (
              <Typography>{crumb.title}</Typography>
            )}
          </li>
        ))}
      </Stack>
    </>
  );
};
export default IncPageBreadcrumbs;
